import { render, staticRenderFns } from "./CrearProductoFi.vue?vue&type=template&id=6a804e14&"
import script from "./CrearProductoFi.vue?vue&type=script&lang=js&"
export * from "./CrearProductoFi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports